import {Component, OnInit} from '@angular/core';
import {ReportService} from '../../../../services/authenticated/report/report.service';
import {ResponseModel} from '../../../../models/response/response.model';
import {Emitters} from '../../../../helpers/core/emitters';
import {UserModel} from '../../../../models/user/user.model';

declare var excelExport: any;

@Component({
    selector: 'app-park-report',
    templateUrl: './park.report.component.html',
})

export class ParkReportComponent implements OnInit {
    public reportData: Array<UserModel>;

    constructor(private reportService: ReportService, private emitters: Emitters) {
    }

    ngOnInit() {
        this.init();
    }

    private init() {
        this.reportData = [];
    }

    public exportReport() {
        const id = 'user-report';
        excelExport(id, id);
    }

    public onSubmit(data) {
        const dataToSend = { ...data };
        const formatDateTime = (dateTimeStr) => {
            const [datePart, timePart, period] = dateTimeStr.split(' '); 
            const [day, month, year] = datePart.split('/'); 
            return `${month}/${day}/${year} ${timePart} ${period}`;
        };
        if (dataToSend.date) {
            dataToSend.date = formatDateTime(dataToSend.date);
        }
        if (dataToSend.end_date) {
            dataToSend.end_date = formatDateTime(dataToSend.end_date);
        }
        this.reportService.park_maintenance(dataToSend).then((response: ResponseModel) => {
            if (response.status) {
                this.reportData = response.data;
                this.emitters.change({ get_report: true });
            }
        });
    }    

    public geMaintenanceStatus(id) {
        if (id == 0) {
            return 'open';
        }
        if (id == 1) {
            return 'close';
        }
        if (id == 2) {
            return 'discard';
        }
        if (id == 3) {
            return 'unanswered';
        }
    }
}
